export const ANCHORS = {
  coverageMap: "coverage-map",
  priceComparison: "price-comparison",
};
